import { render, staticRenderFns } from "./AuditLogItem.vue?vue&type=template&id=cf471f2c&scoped=true&"
import script from "./AuditLogItem.vue?vue&type=script&lang=js&"
export * from "./AuditLogItem.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogItem.vue?vue&type=style&index=0&id=cf471f2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf471f2c",
  null
  
)

export default component.exports